export default __webpack_public_path__ + "static/media/G0860.Breech_04_Pelvic_hold.1695377880000.460980ec.jpg";